import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Axios from "axios";
import Navbar from "../../../components/Navbar";
import Background from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import Input from "../../../components/Input";
import SubmitButton from "../../../components/Button";
import MaskedInput from "../../../components/InputMask";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { SnackbarProvider, useSnackbar } from "notistack";
import style from "./CadastroOperacao.module.css";

const CadastroOperacao = () => {
  useEffect(() => {
    getEmpresas();
    getAgentes();
    getArmadores();
    getBercos();
  }, []);

  const navigate = useNavigate();
  const { id, nome } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const [formData, setFormData] = useState({
    empresa: "",
    agente: "",
    armador: "",
    eta: "",
    etb: "",
    previsao: "",
    rap: "",
    berco: "",
    viagem: "",
    escala: "",
  });

  const [options, setOptions] = useState({
    empresas: [],
    agentes: [],
    armadores: [],
    bercos: [],
  });

  const usuario = JSON.parse(localStorage.getItem("user_token")).id;

  const getEmpresas = () => {
    Axios.get("https://operacao.setlogistica.com.br/api/empresas").then((response) => {
      setOptions((prev) => ({ ...prev, empresas: response.data }));
    });
  };
  const getAgentes = () => {
    Axios.get("https://operacao.setlogistica.com.br/api/agentes").then((response) => {
      setOptions((prev) => ({ ...prev, agentes: response.data }));
    });
  };
  const getArmadores = () => {
    Axios.get("https://operacao.setlogistica.com.br/api/armadores").then((response) => {
      setOptions((prev) => ({ ...prev, armadores: response.data }));
    });
  };
  const getBercos = () => {
    Axios.get("https://operacao.setlogistica.com.br/api/bercos").then((response) => {
      setOptions((prev) => ({ ...prev, bercos: response.data }));
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const getDate = () => {
    const date = new Date();
    date.setHours(date.getHours() - 3);
    return date.toISOString().slice(0, 19).replace("T", " ");
  };

  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant });
  };

  const addOperacao = () => {
    Axios.post("https://operacao.setlogistica.com.br/api/operacao/criar", {
      ...formData,
      navio: id,
      usuario,
      status: "AGUARDANDO DI/BL",
      eta: moment(formData.eta).format("YYYY-MM-DD HH:mm"),
      etb: moment(formData.eta).format("YYYY-MM-DD HH:mm"),
      previsao: moment(formData.previsao).format("YYYY-MM-DD HH:mm"),
      data: getDate(),
    })
      .then((res) => {
        res.data.sqlMessage
          ? showAlert(res.data.sqlMessage, "error")
          : showAlert("Nova viagem cadastrada com sucesso!", "success");
        setTimeout(() => {
          navigate("/api/navios");
        }, 2000);
      });
  };

  const validaDados = () => {
    const { empresa, agente, eta, previsao, rap, berco } = formData;
    if (!empresa || !agente || !eta || !previsao || !rap || !berco) {
      showAlert("Preencha todos os campos!", "error");
      return;
    }
    addOperacao();
  };

  return (
    <>
      <Navbar navios />
      <Header />
      <Background />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div onClick={() => navigate("/api/navios")}>Voltar</div>
            <div className={style.active}>Cadastrar Operação</div>
          </div>
          <div className={style.navio}>
            <i className="fa fa-ship icon"></i>&nbsp;&nbsp;&nbsp;{nome}
          </div>

          {/* Três colunas para Empresa, Agente, e Armador */}
          <div className={style.columnsThree}>
            <div className={style.itens}>
              <label>Empresa:</label>
              <select name="empresa" onChange={handleChange}>
                <option disabled selected>
                  Selecione uma opção
                </option>
                {options.empresas?.map((val) => (
                  <option key={val.COD_EMPRESA} value={val.COD_EMPRESA}>
                    {val.NOME_EMPRESA}
                  </option>
                ))}
              </select>
            </div>
            <div className={style.itens}>
              <label>Agente:</label>
              <select name="agente" onChange={handleChange}>
                <option disabled selected>
                  Selecione uma opção
                </option>
                {options.agentes?.map((val) => (
                  <option key={val.COD_AGENTE} value={val.COD_AGENTE}>
                    {val.NOME_AGENTE}
                  </option>
                ))}
              </select>
            </div>
            <div className={style.itens}>
              <label>Armador:</label>
              <select name="armador" onChange={handleChange}>
                <option disabled selected>
                  Selecione uma opção
                </option>
                {options.armadores?.map((val) => (
                  <option key={val.COD_ARMADOR} value={val.COD_ARMADOR}>
                    {val.NOME_ARMADOR}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Colunas para ETA, Previsão de Atracação, e RAP */}
          <div className={style.columns}>
            <div className={style.itens}>
              <Input
                type={"datetime-local"}
                text={"ETA"}
                name="eta"
                value={formData.eta}
                onChange={handleChange}
              />
            </div>

            <div className={style.itens}>
              <Input
                type={"datetime-local"}
                text={"ETB"}
                name="etb"
                value={formData.etb}
                onChange={handleChange}
              />
            </div>

            <div className={style.itens}>
              <Input
                type={"datetime-local"}
                text={"Previsão de Atracação"}
                name="previsao"
                value={formData.previsao}
                onChange={handleChange}
              />
            </div>

            <div className={style.itens}>
              <MaskedInput
                text={"RAP"}
                mask={"9999-9/9999"}
                name="rap"
                value={formData.rap}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className={style.columns}>
            <div className={style.itens}>
              <label>Berço:</label>
              <select name="berco" onChange={handleChange}>
                <option disabled selected>
                  Selecione uma opção
                </option>
                {options.bercos?.map((val) => (
                  <option key={val.COD_BERCO} value={val.COD_BERCO}>
                    {val.NOME_BERCO}
                  </option>
                ))}
              </select>
            </div>

            <div className={style.itens}>
              <Input
                type={"text"}
                text={"Viagem"}
                name="viagem"
                value={formData.viagem}
                onChange={handleChange}
              />
            </div>

            <div className={style.itens}>
              <Input
                type={"text"}
                text={"Escala"}
                name="escala"
                value={formData.escala}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Botão de cadastrar */}
          <SubmitButton text={"Cadastrar"} onClick={validaDados} />
        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <CadastroOperacao />
    </SnackbarProvider>
  );
}
